import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { Container, Row, Col } from "reactstrap"
import { LinkSearchReplace } from "utils/LinkSearchReplace"
import googlePlay from "images/google-play.png"
import appleStore from "images/apple-store.png"

const ContainerStyled = styled(Container)`
  background-color: ${props => props.theme.colors.primary};
  text-align: center;
  color: ${props => props.theme.colors.white};
  .wrapper {
    width: 90%;
    margin: 0 auto;
    padding-bottom: 2rem;
    max-width: 550px;
  }
  h3 {
    padding-top: 1rem;
    color: ${props => props.theme.colors.white};
    font-family: ${props => props.theme.font.family.heading};
    font-size: ${props => props.theme.font.size.xl};
  }
  p {
      font-size: ${props => props.theme.font.size.base};
      font-family: ${props => props.theme.font.family.proxima};
      font-weight: 200;
      padding: .5rem 0;
    }
    
  a {
    display: block;
  }
`

const FooterApp = (props) => {
	const data = useStaticQuery(graphql`
		query {
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

  const { 
    appTitle,
    appText,
    googlePlayLink,
    appleStoreLink
  } = data.allWp.edges[0]?.node?.options?.acfOptions

  return (
    <ContainerStyled fluid className="py-4">
      <div className="wrapper">
        {appTitle &&
          <h3>{appTitle}</h3>
        }
        {appText &&
          <div dangerouslySetInnerHTML={{ __html: LinkSearchReplace(appText) }} />
        }
        <Row className="justify-content-center pt-3 btn-wrapper">
          {appleStoreLink &&
            <Col xs="5">
              <a href={appleStoreLink} target="_blank" rel="noopener noreferrer">
                <img src={appleStore} alt="Apple Store" />
              </a>
            </Col>
          }
          {googlePlayLink &&
            <Col xs="5">
              <a href={googlePlayLink} target="_blank" rel="noopener noreferrer">
                <img src={googlePlay} alt="Google Play Store" />
              </a>
            </Col>
          }
        </Row>
      </div>
    </ContainerStyled>
  )
}

export default FooterApp